import { DrawerProps } from 'components/Drawer/Root'
import { Drawer } from 'components/Drawer'
import { BrandKitMenu } from 'screens/BrandKit/BrandKitMenu/BrandKitMenu'
import { BrandKit } from 'types'
import { Key, useMemo } from 'react'
import { Item } from 'components/Menu/MenuItem'
import { ChevronRightSmall, UserProfileCircle } from 'blaze-ui/icons'
import { LinkedAccountsDrawer } from 'screens/BrandKit/LinkedAccountsDrawer/LinkedAccountsDrawer'
import { useRootStore } from 'stores/RootStore'
import { useBrandKitSources } from 'hooks/queries/useBrandKitSources'
import { collectResults } from 'utils/query'
import { Panel } from 'screens/BrandKit/LinkedAccountsDrawer/consts'
import { Counter } from 'blaze-ui/Counter/Counter'
import { observer } from 'mobx-react-lite'
import { Heading } from 'blaze-ui/Heading/Heading'

interface Props extends DrawerProps {
  brandKit: BrandKit
}

export const BrandKitMenuDrawer = observer(({ brandKit, ...props }: Props) => {
  const { drawersStore } = useRootStore()
  const { openDrawer } = drawersStore
  const linkedAccountsQuery = useBrandKitSources(
    { brandKitId: brandKit.id, sourceType: ['ExternalIntegration'] },
    { cacheTime: 1000 * 60 * 5 },
  )
  const linkedAccounts = collectResults(linkedAccountsQuery, (data) => data.brand_kit_sources)

  const linkedAccountPanel = useMemo(() => {
    if (linkedAccounts.length > 0) {
      return Panel.ManageAccounts
    }

    return Panel.SelectAccounts
  }, [linkedAccounts])

  const handleMenuAction = async (key: Key) => {
    switch (key) {
      case 'rename':
        props.onClose?.()
        return
      case 'linked_accounts':
        openDrawer(LinkedAccountsDrawer, { brandKitId: brandKit.id, initialPanel: linkedAccountPanel })
        return
    }
  }

  return (
    <Drawer.Root {...props}>
      <Drawer.Portal>
        <Drawer.Content>
          <Drawer.InnerContent>
            <Drawer.Top>
              <div />
              <Drawer.Title asChild>
                <Heading level={5}>More Options</Heading>
              </Drawer.Title>
              <Drawer.Close variant="ghost" position="right" />
            </Drawer.Top>
            <Drawer.Container>
              <BrandKitMenu brandKit={brandKit} menuType="tray" onAction={handleMenuAction}>
                {(collection) => [
                  <Item
                    key="linked_accounts"
                    textValue="Linked Accounts"
                    frontIcon={UserProfileCircle}
                    endIcon={ChevronRightSmall}
                    description="Connecting social media accounts helps Blaze create better on-brand content."
                  >
                    Linked Accounts
                    <Counter count={linkedAccounts.length} />
                  </Item>,
                  ...collection,
                ]}
              </BrandKitMenu>
            </Drawer.Container>
          </Drawer.InnerContent>
        </Drawer.Content>
        <Drawer.Overlay />
      </Drawer.Portal>
    </Drawer.Root>
  )
})
